<template>
  <transition>
    <keep-alive>
      <div class="admission-detail">
        <div class="mb20">
          <el-tabs type="border-card" v-model="activeName" class="tab-pane">
            <el-tab-pane label="基本信息" name="userInfo" ref="userInfo">
              <div class="content-item">
                <h4>基本信息</h4>
                <el-row type="flex" class="row-bg">
                  <el-col :span="6" :offset="2" style="padding-bottom: 5px;">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24">
                          <label>老人姓名:</label>
                          <span>{{ oldInfo.oldName }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>老人性别:</label>
                          <span>{{ oldInfo.sex }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>老人年龄:</label>
                          <span>{{ oldInfo.oldAge }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>身份证号码:</label>
                          <span>{{ oldInfo.oldIdCard }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>电话号码:</label>
                          <span>{{ oldInfo.oldPhone }}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="6" :offset="2" style="padding-bottom: 5px;">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24">
                          <label>籍贯:</label>
                          <span>{{ oldInfo.ancestral }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>婚姻状况:</label>
                          <span>{{ oldInfo.mStatus }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>当前补贴:</label>
                          <span>{{ oldInfo.occupation }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>老人类别:</label>
                          <span>{{ oldInfo.interest }}</span>
                        </el-col>
                        <el-col style="display:flex">
                          <label>现居住地址:</label>
                          <p style="flex:1;margin-left:5px">{{ oldInfo.oldAddress }}</p>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="5" :offset="2" style="padding-bottom: 5px;">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24" style="display:flex">
                          <span style="font-size:16px">老人身份码:</span>
                          <div style="width: 120px;height: 120px;margin-top:20px;margin-left:10px" :id="qcode" :ref="qcode"></div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="content-item">
                <h4>紧急联系人</h4>
                <el-row type="flex" class="row-bg">
                  <el-col :span="6" :offset="2" style="padding-bottom: 5px;">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24">
                          <label>紧急联系人:</label>
                          <span>{{ oldInfo.egNamea }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>联系人电话:</label>
                          <span>{{ oldInfo.egPhonea }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>身份证号:</label>
                          <span>{{ oldInfo.egaIdCard }}</span>
                        </el-col>
                        <el-col style="display:flex">
                          <label>家庭住址:</label>
                          <p style="flex:1;margin-left:5px">{{ oldInfo.egaAddress }}</p>
                        </el-col>
                        <el-col :span="24">
                          <label>与老人关系:</label>
                          <span>{{ oldInfo.relationshipa }}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="6" :offset="2">
                    <div class="info-content bg">
                      <el-row>
                        <el-col :span="24">
                          <label>家属姓名:</label>
                          <span v-if="oldInfo.egNameb == null || oldInfo.egNameb == ''
                            ">无</span>
                          <span v-else>{{ oldInfo.egNameb }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>联系电话:</label>
                          <span v-if="oldInfo.egPhoneb == null || oldInfo.egPhoneb == ''
                            ">无</span>
                          <span v-else>{{ oldInfo.egPhoneb }}</span>
                        </el-col>
                        <el-col :span="24">
                          <label>与老人关系:</label>
                          <span v-if="oldInfo.relationshipb == null ||
                            oldInfo.relationshipb == '' ||
                            oldInfo.relationshipb == -1
                            ">无</span>
                          <span v-else>{{ oldInfo.relationshipb }}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="content-item">
                <h4>长者入院合同</h4>
                <div class="img_box" v-if="olderPicDetail.idCardPic!=null && olderPicDetail.idCardPic.length >10">
                  <el-image class="img" v-if="imgurl.length >10" :key="imgurl" v-for="imgurl in olderPicDetail.idCardPic.split(',')" :preview-src-list="olderPicDetail.idCardPic.split(',')" :src="imgurl"/>
                </div>
              </div>
              <div class="content-item">
                <h4>失能人员鉴定表</h4>
                <div class="img_box" v-if="olderPicDetail.outPic!=null && olderPicDetail.outPic.length >10">
                  <el-image class="img" v-if="imgurl.length >10"
                     :key="imgurl" v-for="imgurl in olderPicDetail.outPic.split(',')" :preview-src-list="olderPicDetail.outPic.split(',')" :src="imgurl"/>
                </div>
                
              </div>
              <div class="content-item">
                <h4>发票记录</h4>
                <div class="img_box" v-if="olderPicDetail.otherPic!=null && olderPicDetail.otherPic.length >10">
                  <el-image class="img" v-if="imgurl.length >10" :key="imgurl" v-for="imgurl in olderPicDetail.otherPic.split(',')" :preview-src-list="olderPicDetail.otherPic.split(',')" :src="imgurl"/>
                </div>
              </div>

            </el-tab-pane>

            <el-tab-pane label="健康信息" name="health" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:0px;">
                  <div class="content">
                    <div class="content-item">
                      <h4>老人健康情况</h4>
                      <el-row type="flex" class="row-bg">
                        <el-col :span="8" :offset="2">
                          <label style="width:80px;display: inline-block;">慢性病:</label>
                          <span v-if="oldInfo.chronicDis != ''">{{ oldInfo.chronicDis }}{{ oldInfo.crcDisOther }}</span>
                          <span v-else>无</span>
                        </el-col>
                      </el-row>
                    </div>

                    <div class="content-item">
                      <h4>健康记录</h4>
                      <el-row style="margin-top:10px;">
                        <el-table :data="healthRecordList" style="width: 100%" :row-style="tableRowStyle"
                          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                            'text-align': 'center',
                            'font-size': '16px',
                            'font-weight': '600',
                            color: '#2d2d2d',
                            'background-color': '#d4f5fa',
                          }">
                          <el-table-column prop="deviceNo" label="设备编号" align="center"></el-table-column>
                          <el-table-column prop="category" label="测量类型" align="center"></el-table-column>
                          <el-table-column prop="value" label="测量结果" align="center"></el-table-column>
                          <el-table-column prop="result" label="说明" show-overflow-tooltip
                            align="center"></el-table-column>
                          <el-table-column prop="createdTime" label="测量时间" align="center" width="180px"></el-table-column>
                        </el-table>
                        <el-col style="margin-top:10px">
                          <el-pagination background @current-change="healthRecordPageChange" :current-page="consumptionPage"
                          layout="total, prev, pager, next" :total="healthRecordTotal" align="center"
                          class="fenye"></el-pagination>
                        </el-col>  
                      </el-row>
                      
                    </div>

                  </div>
                </el-row>
              </div>
            </el-tab-pane>

            <el-tab-pane label="自理评估" name="evaluation">
              <div class="evaluation-wrapper">
                <div class="evaluation-item">
                  <h4>评估视频</h4>
                  <div class="video-wrapper">
                    <video poster="@/assets/common/poster.png" ref="video" controls class="daily-video">
                      <source :src="videoUrl" type="video/mp4" />
                      你的浏览器不支持video标签，请更新浏览器
                    </video>
                  </div>
                </div>
                <div class="evaluation-item evaluation-con">
                  <h4>自理评估</h4>
                  <div class="rate-con">
                    <p>{{ operatorList.levelCareName }}</p>
                  </div>
                  <div class="evalution-project">
                    <h4>评估项目</h4>
                    <p class="evaluation-desc">
                      <span>
                        <label>负责人:</label> {{ operatorList.evaluator }}
                      </span>
                      <span class="no-break">
                        <label>评估时间:</label>
                        {{ operatorList.evaluatorSignDate }}
                      </span>
                    </p>
                    <el-steps :active="classType.length" align-center>
                      <div v-for="(index, item) in classType" :key="index">
                        <el-step :title="item.grade" :description="item.desc"></el-step>
                      </div>
                    </el-steps>
                  </div>
                  <div class="evalutaion-table">
                    <el-button type="primary" @click="evaluationDetail" plain>评估详情</el-button>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="消费记录" name="payment" class="payment-transction">
              <div class="olderDetailFee">
                <el-row style="margin-top:10px;">
                  <el-table :data="consumptionRecordList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '16px',
                      'font-weight': '600',
                      color: '#2d2d2d',
                      'background-color': '#d4f5fa',
                    }">
                    <el-table-column prop="oldName" label="老人姓名" align="center"></el-table-column>
                    <el-table-column prop="type" label="费用类型" :formatter="formatType" align="center"></el-table-column>
                    <el-table-column prop="projectType" label="项目类别" :formatter="formattype2"
                      align="center"></el-table-column>
                    <el-table-column prop="projectName" label="费用项目" align="center"></el-table-column>
                    <el-table-column prop="consumptionFee" label="金额" align="center"></el-table-column>
                    <el-table-column prop="createdTime" label="发生时间" align="center" width="180px"></el-table-column>
                  </el-table>
                  <el-pagination background @current-change="consumptionPageChange" :current-page="consumptionPage"
                    layout="total, prev, pager, next" :total="consumptionTotal" align="center"
                    class="fenye"></el-pagination>
                </el-row>
              </div>
            </el-tab-pane>

          </el-tabs>
          <div class="backButton">
            <el-button type="warning" icon="el-icon-back" plain @click="backHome">返回</el-button>
          </div>
        </div>
        <!-- 弹出层能力评估 -->
        <el-dialog :visible.sync="evaluationDialog" :close-on-click-modal="false" center>
          <div slot="title" class="dialog-title">老年人能力评估表</div>
          <div class="dialog-content">
            <el-tabs type="border-card">
              <el-tab-pane v-for="(bigItem, i) in pgData" :key="i" :label="bigItem.baseTypeName">
                <div class="desc-item" v-for="(smallItem, j) in bigItem.bigItemList" :key="j">
                  <div class="desc-wrapper">
                    <div class="desc-title">{{ smallItem.bigItemName }}</div>
                  </div>
                  <div class="radio-wrapper">
                    <div v-for="(selectItem, k) in smallItem.minorItemList" :key="k">
                      <span class="smallItem light">{{
                        selectItem.grade
                      }}</span>
                      <span class="smallItem light">{{
                        selectItem.minorItemName
                      }}</span>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-dialog>
      </div>
    </keep-alive>
  </transition>
</template>
<script type="text/javascript">
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import QRCode from 'qrcodejs2';//二维码
export default {
  data() {
    return {
      activeName: "userInfo", //选项卡
      videoUrl: "", //视屏资源的url
      videoPath: "",
      operatorList: [], //评估的
      classType: [],
      qcode: 'qcode',
      consumptionPage: 1,
      consumptionRecordList: [],
      orderPage: 1,
      orderList: [],
      olderPicDetail:{},
      orderTotal: 0,
      consumptionTotal: 0,
      oldInfo: "", //老人基本信息
      evaluationDialog: false, //评估的dialog弹出框
      pgData: [], //弹出框的数据
      oldmanInfo: {
        oldName: "",
        sex: "",
        idCardNum: "",
        inDate: "",
        bedId: ""
      },
      bedNo: "",
      tableData: [],
      spanArr: [],
      pos: 0,
      feeTableList: [],
      bindFeeList: [],
      healthRecordList:[],
      healthRecordTotal:0,
    };
  },
  methods: {
    /* 
      返回
    */
    backHome() {
      bus.$emit("close_current_tags");
    },
    /* 
      处理表格的数据 用于合并表格
    */
    getSpanArr(data) {
      this.spanArr = []; //重置数据，防止数据累加
      this.pos = 0; //重置数据，防止数据累加
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同  通过表格中的 modelCode模块的modelCode字段来判断 它们是否是一类
          if (data[i].modelCode === data[i - 1].modelCode) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
      console.log(this.spanArr, "this.spanArr");
    },

    /* 
      表格 类别的合并
    */
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //console.log(this.spanArr,"this.spanArr...........................");
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        console.log(_row, _col);
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },

    /* 
      查询老人的服务类型
    */
    queryOldmanInType() {
      let params = new Object();
      params.oldmanId = this.oldmanId;
      // this.$postForm("omc/Oldman/oldmanInType", params).then(res => {
      //   if (res.result != null || res.result.length > 0) {
      //     this.oldmanInfo.serviceType = res.result[0].serviceType; //服务类型 1----居家   2----入院
      //   }
      // });
    },
    queryBedInfoByOldId() {
      //omc/Bed/selectByOldId
      let params = new Object();
      params.oldmanId = this.oldmanId;
      this.$postForm("omc/Bed/selectByOldId", params).then(res => {
        if (res.result != null) {
          this.bedNo = res.result.roomNo + "-" + res.result.bedNo;
        } else {
          //该老人没有床位
          this.bedNo = "暂无床位"
        }
      });
      // omc/Oldman/selectOldManSupByOld
    },
    /* 
      评估详情
    */
    evaluationDetail() {
      this.evaluationDialog = true;
    },
    queryConsumptionList() {
      let param = {
        oldId: this.oldmanId,
        pageNum: this.consumptionPage,
        pageSize: 10,
      };
      this.$postJson("omc/account/queryConsumptionRecord", param).then((res) => {
        this.consumptionRecordList = res.result.list; //列表数据
        this.consumptionTotal = Number(res.result.total); //页码total
      });

      this.$postJson("omc/account/queryBindFeeList", param).then((res) => {
        this.bindFeeList = res.result; //列表数据
      });
    },
    orderPageChange(val) {

    },
    healthRecordPageChange(val){
      this.consumptionPage = val;
      this.queryHealthList();
    },
    queryHealthList() {
      let param = {
        idCard: this.oldInfo.oldIdCard,
        pageNum: this.consumptionPage,
        pageSize: 10,
      };
      this.$postJson("dmc/oldHealth/showByOld", param).then((res) => {
        this.healthRecordList = res.result.list; //列表数据
        console.log(this.healthRecordList);
        this.healthRecordTotal = Number(res.result.total); //页码total
      });

      
    },
    consumptionPageChange(val) {
      this.consumptionPage = val;
      this.queryConsumptionList();
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    formattype2(row) {
      if (row.type == 5) {
        if (row.projectType == "1") {
          return "现金支付";
        } else if (row.projectType == "2") {
          return "刷卡支付";
        } else if (row.projectType == "3") {
          return "移动支付";
        } else {
          return row.projectType;
        }
      } else {
        return row.projectType;
      }
    },
    formatType(row) {
      // 0 按天消费 1 按月消费 2 单次服务收费  5 充值
      if (row.type == 0) {
        return "按天消费";
      } else if (row.type == 1) {
        return "按月消费";
      } else if (row.type == 2) {
        return "单次服务收费";
      } else if (row.type == 5) {
        return "充值";
      } else {
        return "其他费用";
      }
    },

    formatBindFeeType(row) {
      // 0 按天消费 1 按月消费 2 单次服务收费  5 充值
      if (row.type == 1) {
        return "按天扣费";
      } else if (row.type == 2) {
        return "按月扣费";
      } else {
        return "按次扣费";
      }
    },
    /* 
      获取已经评估过的老人
    */
    getEvaluateList() {
      let params = new Object();
      params.pageNo = "0";
      params.pageSize = "0";
      this.$postJson("cac/CacOldman/showAll", params).then(res => {
        if (res.result != 0) {
          var cacId = "";
          res.result.list.forEach(item => {
            if (this.oldmanId == item.oldmanId) {
              cacId = item.cacId;
              this.getEvaluationDatas(cacId);
            }
          });
        }
      });
    },

    /* 
      通过评估id去请求评估数据  
    */
    getEvaluationDatas(cacId) {
      console.log(cacId);
      var para = {
        cacId: cacId
      };
      // 通过评估id去请求评估数据
      this.$postForm("cac/CacOldman/selectByCacId", para).then(res => {
        if (res.status || res.code == 200) {
          this.selectedList = res.result.oldmanMinList;
          this.operatorList = res.result.cacOldman;
          this.videoFlag = res.result.cacOldman.videoId;
          console.log(this.operatorList);
          this.transfromList(this.operatorList);
          this.getVideoPlay();
          this.getDialogEvaluation(cacId);
        }
      });
    },

    /* 
      处理护理评估的等级的数据回显
    */
    transfromList(data) {
      switch (data.finalGrade) {
        case 0:
          data.finalGrade = "能力完好";
          break;
        case 1:
          data.finalGrade = "轻度失能";
          break;
        case 2:
          data.finalGrade = "中度失能";
          break;
        case 3:
          data.finalGrade = "重度失能";
          break;
      }
    },

    /* 
      获取视屏资源
    */
    getVideoPlay() {
      console.log(this.videoFlag);
      if (this.$refs.video) {
        this.$refs.video.src = this.videoFlag;
      }
      // this.$postForm("opc/file/queryAttachmentById/" + this.videoFlag).then(
      //   res => {
      //     console.log(res);
      //     if (res.status || res.code == 200) {
      //       //this.videoUrl = 'http:/51cs8.com/cmny/file/581164927180356608.mp4';
      //       this.videoPath =
      //         "http://47.104.3.68:7009/" + res.result.path + res.result.name;
      //       console.log(this.$refs.video);
      //       if (this.$refs.video) {
      //         this.$refs.video.src = this.videoPath;
      //         console.log(this.videoPath);
      //       }
      //     } else {
      //       this.$message.error(res.message);
      //     }
      //   }
      // );
    },

    /* 
      获取dialog模态框的评估的大项数据
    */
    getDialogEvaluation(cacId) {
      let params = new Object();
      params.oldmanId = this.oldmanId;
      params.cacId = cacId;
      this.$postForm("cac/CacOldmanMinor/selectCacOldMnr", params).then(res => {
        console.log(res, "-----000000");
        if (res.status || res.code == 200) {
          this.pgData = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 
      获取老人的基本信息
    */
    getOldmanInfo() {
      let params = new Object();
      params.oldmanId = this.oldmanId;
      console.log(params);
      this.$postForm("omc/Oldman/selectByOldId", params).then(res => {
        this.tranformBaseInfo(res.result);
        this.queryHealthList();
      });
      //omc/Oldman/selectOldManSupByOld
      this.$postForm("omc/Oldman/selectOldManSupByOld", params).then(res=>{
        this.olderPicDetail = res.result;

      })


    },

    /* 
      处理老人基本信息的数据
    */
    tranformBaseInfo(data) {
      data.sex = data.sex == 0 ? "男" : "女";
      switch (data.relationshipa) {
        case 1:
          data.relationshipa = "子女";
          break;
        case 2:
          data.relationshipa = "兄弟姐妹";
          break;
        case 3:
          data.relationshipa = "旁系亲属";
          break;
        case 4:
          data.relationshipa = "朋友";
          break;
        case 5:
          data.relationshipa = "其他";
          break;
      }
      switch (data.relationshipb) {
        case 1:
          data.relationshipb = "子女";
          break;
        case 2:
          data.relationshipb = "兄弟姐妹";
          break;
        case 3:
          data.relationshipb = "旁系亲属";
          break;
        case 4:
          data.relationshipb = "朋友";
          break;
        case 5:
          data.relationshipb = "其他";
          break;
      }
      switch (data.economicSource) {
        case 1:
          data.economicSource = "无";
          break;
        case 2:
          data.economicSource = "低保";
          break;
        case 3:
          data.economicSource = "低保边缘户";
          break;
        case 4:
          data.economicSource = "退休金/养老金";
          break;
        case 5:
          data.economicSource = "子女补贴";
          break;
        case 6:
          data.economicSource = "亲友资助";
          break;
      }
      switch (data.oldMonIncome) {
        case "0":
          data.oldMonIncome = "无";
          break;
        case "1":
          data.oldMonIncome = "1000";
          break;
        case "2":
          data.oldMonIncome = "2000";
          break;
        case "3":
          data.oldMonIncome = "3000";
          break;
        case "4":
          data.oldMonIncome = "4000";
          break;
        case "5":
          data.oldMonIncome = "5000";
          break;
        case "6":
          data.oldMonIncome = "5000+";
          break;
        default:
          data.oldMonIncome = data.oldMonIncome;
      }

      if (data.oldEctLel) {
        switch (data.oldEctLel) {
          case 1:
            data.oldEctLel = "无";
            break;
          case 2:
            data.oldEctLel = "文盲";
            break;
          case 3:
            data.oldEctLel = "小学";
            break;
          case 4:
            data.oldEctLel = "初中";
            break;
          case 5:
            data.oldEctLel = "高中";
            break;
          case 6:
            data.oldEctLel = "大专及以上";
            break;
        }
      }
      if (data.chronicDis != null) {
        var chronicDis = data.chronicDis.split("-");
        var chronic = "";
        if (chronicDis[0] == 1) {
          chronic = chronic + "高血压 ";
        }
        if (chronicDis[1] == 1) {
          chronic = chronic + "糖尿病 ";
        }
        if (chronicDis[2] == 1) {
          chronic = chronic + "高血脂 ";
        }
        if (chronicDis[3] == 1) {
          chronic = chronic + "心脏病 ";
        }
        if (chronicDis[4] == 1) {
          chronic = chronic + "风湿病 ";
        }
        if (chronicDis[5] == 1) {
          chronic = chronic + " ";
        }
        data.chronicDis = chronic;
      } else {
        data.chronicDis = "";
      }


      switch (data.mStatus) {
        case 1:
          data.mStatus = "未婚";
          break;
        case 2:
          data.mStatus = "已婚";
          break;
        case 3:
          data.mStatus = "丧偶";
          break;
        case 4:
          data.mStatus = "离异";
          break;
        case 5:
          data.mStatus = "未说明婚姻状况";
          break;
      }
      if (this.qrcode) {  // 有新的二维码地址了，先把之前的清除掉
        this.$refs[this.qcode].innerHTML = ''
      }
      this.qrcode = new QRCode(this.$refs[this.qcode], {
        text: this.oldmanId, //页面地址 ,如果页面需要参数传递请注意哈希模式#
        width: 120, // 二维码宽度 （不支持100%）
        height: 120, // 二维码高度 （不支持100%）
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      })
      let nations = [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族"
      ];
      data.nation = nations[data.nation];
      if (data.registryTime != null) {
        data.inDate = data.registryTime;
      } else {
        var date = new Date(data.createTime)
        var Y = date.getFullYear()
        var M = date.getMonth() + 1
        var D = date.getDate()
        data.inDate = Y + '-' + (M < 10 ? '0' + M : M) + '-' + (D < 10 ? '0' + D : D)
      }
      data.bedNo = data.roomNo + '-' + data.bedNo;
      this.oldInfo = data;
      console.log(this.oldInfo);
    },

    /* 
      表头的颜色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#fff;color:#6f7075;font-weight: 700;height:100px;";
      }
    }
  },
  created() {
    this.oldmanId = sessionStorage.getItem("oldmanId");
    console.log(this.oldmanId);
    if (
      this.oldmanId != null ||
      this.oldmanId != undefined ||
      this.oldmanId != ""
    ) {
      this.queryOldmanInType();
      this.getOldmanInfo();
      this.getEvaluateList();
      this.queryBedInfoByOldId();
      this.queryConsumptionList();
    }
  },
  mounted() { }
};
</script>

<style lang="scss" scoped>
.admission-detail {
  // padding: 20px;
  position: relative;
  padding-top: 5px;

  .mb20 {
    margin-bottom: 20px;

    ::v-deep .el-tabs__item {
      margin-right: 10px;
      background: #ccc;

      &.is-active {
        background: #fff;
      }
    }

    ::v-deep .el-tabs__content {
      background: #fff;
    }

    .el-col {
      border-radius: 4px;
    }

    .bg {
      background: #fff;
      box-shadow: 0 0px 15px rgba(0, 0, 0, 0.1);
    }
    
    .img_box{
      flex:1;
      display:flex;
      height:88px;
      .img{
        width:78px;
        height:78px;
        margin:5px;
      }
    }
    .el-tab-pane {
      .content-item {
        overflow: hidden;
        margin-bottom: 20px;

        .info-content {
          border-radius: 5px;
          min-height: 150px;
          overflow: hidden;
          line-height: 30px;
          padding: 5px;

          label {
            display: inline-block;
            width: 90px;
          }
        }
      }

      .evaluation-wrapper {
        background: #f5f7fa;
        padding: 10px 50px;
        overflow: hidden;

        .evaluation-item {
          width: 40%;
          float: left;
          background: #fff;
          min-height: 470px;
          padding: 5px 30px 5px 20px;
          border-radius: 5px;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

          .video-wrapper {
            width: 80%;
            margin: 0 auto;

            .daily-video {
              width: 100%;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

              &:hover {
                cursor: pointer;
              }
            }
          }

          .centerVideo {
            margin: 0 auto;

            .daily-video,
            .status-video {
              width: 100%;
              border-radius: 5px;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
              cursor: pointer;
              border: 1px solid #f01400;
              margin: 0 auto;
            }
          }

          .evalution-project {
            .evaluation-desc {
              margin-left: 30px;
              margin-bottom: 50px;

              .no-break {
                display: block;
              }

              span {
                margin-right: 20px;

                label {
                  margin-right: 10px;
                }
              }
            }
          }

          .evalutaion-table {
            text-align: center;
            margin: 20px 0px;
          }

          &.evaluation-con {
            float: right;

            .rate-con {
              width: 250px;
              margin: 0 auto;
              text-align: center;
              color: #82848a;

              .rate {
                color: #5daf34;
                font-size: 20px;
                font-weight: 700;
              }
            }
          }
        }
      }
    }
  }

  .el-dialog__wrapper {
    z-index: 99999 !important;
  }

  ::v-deep .el-dialog {
    width: 60%;

    .el-table {
      border-radius: 5px;
    }

    ::v-deep .el-dialog__header {
      text-align: left;
      background: #cccccc3d;
      border-bottom: 1px solid #ddd;
    }

    .el-dialog__body {
      .el-form-item {
        margin-bottom: 0;

        .el-form-item__content {
          .el-tooltip {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;

            &.el-button {
              text-align: left;
              border: none;
              padding: 0;
            }
          }
        }

        ::v-deep .el-form-item__label {
          color: #333;
          padding-right: 30px;
        }
      }
    }

    .dialog-content {
      height: 400px;
      overflow: auto;

      ::v-deep .el-tabs__item {
        margin-right: 10px;
        background: #ccc;

        &.is-active {
          background: #fff;
        }
      }

      ::v-deep .el-tabs__content {
        background: #ecf5ff;
      }

      .desc-item {
        width: 100%;
        min-height: 40px;
        padding: 5px 0;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: center;
        align-items: center;

        .desc-wrapper {
          width: 30%;
        }

        .radio-wrapper {
          width: 65%;
          margin-left: 30px;

          .el-radio__label {
            font-size: 12px;
          }

          .smallItem {
            margin-right: 30px;

            &.light {
              color: #409eff;
            }
          }
        }
      }
    }
  }
}

::v-deep .el-step {
  position: relative;

  .el-step__title {
    position: absolute;
    top: -30px;
    left: 40%;
    font-size: 12px;
  }

  .el-step__description {
    padding-top: 10px;
  }
}

.backButton {
  position: absolute;
  top: 8px;
  right: 1px;
  z-index: 2;
}

.content-item {
  overflow: hidden;

  .psn-item {
    margin-right: 25px;
  }

  .Fee {
    font-weight: 700;
    color: #166ad0;
    font-size: 15px;
  }

  .rt {
    float: right;
    margin-right: 100px;
  }
}

.content-item {
  overflow: hidden;
  margin: 20px 0;

  .title {
    text-align: left;
    font-weight: bolder;
    font-size: 15px;
  }

  .money-desc {
    float: right;
    margin-right: 100px;
    font-weight: 700;
    color: #166ad0;
    font-size: 15px;
  }
}

.showPayment {
  ::v-deep .el-form-item__label {
    width: 120px !important;
    margin-right: 10px;
  }
}

.payment-form {
  margin-left: 30px;
}

.payment-lable {
  width: 200px;

  ::v-deep .el-form-item__label {
    font-weight: 700;
    font-size: 14px;
    color: #000;
  }
}

.olderDetailFee {
  overflow: hidden;

  .content {
    overflow: hidden;
  }

  .content-item {
    margin-bottom: 10px;
  }

  .title {
    height: 54px;
    line-height: 54px;
    background: #f9f7fa;
    border: 1px #f1eff2 solid;

    .span-img {
      height: 54px;
      line-height: 54px;
      margin-left: 10px;
    }

    .span-text {
      height: 54px;
      line-height: 54px;
      font-size: 16px;
    }
  }

  .topstr {
    margin-top: 20px;
    margin-bottom: 20px;
    padding-left: 10px;
    font-size: 14px;
  }

  table {
    width: 100%;
    margin: 10px auto;
    border-collapse: collapse;
    border: 1px solid #cccccc;
  }

  .tr {
    height: 100px;
    text-align: center;
  }

  .tdStyle {
    color: #6f7075;
    font-weight: 700;
    height: 50px;
  }

  td {
    border: 1px solid #cccccc;
  }

  .mBottom30 {
    margin-bottom: 40px;
  }

  .footer {
    padding: 30px 0;
    background: #fff;
  }
}
</style>
